// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container__gvuDL","tooltip":"Tooltip_tooltip__6e+D3","content":"Tooltip_content__ksCxw","img":"Tooltip_img__U2kLM","description":"Tooltip_description__htB8x"};